import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { UserAcdExtensionInfoRemoteDto } from '../../../../generated/signalR/user-acd-extension-info-remote-dto';
import { AcdTypeEnum } from '../../../samwebDescription/samwin/AcdTypeEnum';
import { SamwinAcdExtensionState, SamwinAcdExtensionStateModel } from './samwin-acd-extension.state';

export class SamwinAcdExtensionStateSelectors {
   @Selector([SamwinAcdExtensionState])
   public static getAcdExtensionSearchValue(state: SamwinAcdExtensionStateModel) {
      return state.acdExtensionSearchValue;
   }

   @Selector([SamwinAcdExtensionState])
   public static getCurrentDeviceAddress(state: SamwinAcdExtensionStateModel): string {
      return state.currentDeviceAddress;
   }

   @Selector([SamwinAcdExtensionStateSelectors.getCurrentDeviceAddress, SamwinAcdExtensionStateSelectors.getCurrentAcdExtension])
   public static isCurrentDeviceAddressAlternativeDevice(currentDeviceAddress: string, acdExtension: UserAcdExtensionInfoRemoteDto) {
      return !_.isNil(acdExtension) && acdExtension.acdNumber !== currentDeviceAddress;
   }

   @Selector([SamwinAcdExtensionState])
   public static getCurrentAcdExtension(state: SamwinAcdExtensionStateModel): UserAcdExtensionInfoRemoteDto {
      return _(state.availableAcdExtensions).find((x) => x.opextId === state.assignedAcdExtension);
   }

   @Selector([SamwinAcdExtensionStateSelectors.getCurrentAcdExtension])
   public static getCurrentAcdExtensionLineType(currentAcdExtension: UserAcdExtensionInfoRemoteDto): AcdTypeEnum {
      if (_.isNil(currentAcdExtension)) {
         return AcdTypeEnum.NONE;
      }
      return AcdTypeEnum.getAcdTypeFromAcdLine(currentAcdExtension.acdLine);
   }

   @Selector([
      SamwinAcdExtensionStateSelectors.getCurrentAcdExtension,
      SamwinAcdExtensionStateSelectors.getCurrentAcdExtensionLineType,
      SamwinAcdExtensionStateSelectors.getCurrentDeviceAddress,
   ])
   public static canAcdExtensionAcceptCall(currentAcdExtension: UserAcdExtensionInfoRemoteDto, acdType: AcdTypeEnum, currentDeviceAddress: string): boolean {
      if (_.isNil(currentAcdExtension) || _.isNil(acdType)) {
         return false;
      }
      return acdType.canAcceptCall && currentAcdExtension.acdNumber === currentDeviceAddress;
   }

   @Selector([SamwinAcdExtensionStateSelectors.getCurrentAcdExtensionLineType])
   public static getCurrentAcdIcon(currentAcdExtension: AcdTypeEnum): IconDefinition {
      if (_.isNil(currentAcdExtension)) {
         return AcdTypeEnum.UNKNOWN.icon;
      }
      return currentAcdExtension.icon;
   }

   @Selector([SamwinAcdExtensionStateSelectors.getCurrentAcdExtension])
   public static getCurrentAcdExtensionNumber(currentAcdExtension: UserAcdExtensionInfoRemoteDto): string {
      if (_.isNil(currentAcdExtension)) {
         return '';
      }
      return currentAcdExtension.acdNumber;
   }

   @Selector([SamwinAcdExtensionStateSelectors.getCurrentAcdExtension])
   public static getCurrentAcdSkillID(currentAcdExtension: UserAcdExtensionInfoRemoteDto): number {
      if (_.isNil(currentAcdExtension)) {
         return null;
      }
      return currentAcdExtension.defaultSkillId;
   }

   @Selector([SamwinAcdExtensionState])
   public static getAcdExtensions(state: SamwinAcdExtensionStateModel): UserAcdExtensionInfoRemoteDto[] {
      return state.availableAcdExtensions;
   }

   @Selector([SamwinAcdExtensionState])
   public static getFilteredAcdExtensionForSelection(state: SamwinAcdExtensionStateModel): UserAcdExtensionInfoRemoteDto[] {
      return _(state.availableAcdExtensions)
         .filter(
            (x) =>
               _.isEmpty(state.acdExtensionSearchValue) ||
               x.name.toLowerCase().includes(state.acdExtensionSearchValue.toLowerCase()) ||
               x.acdNumber.toLowerCase().includes(state.acdExtensionSearchValue.toLowerCase())
         )
         .orderBy([(x) => x.isAvailable, (x) => x.name.toLowerCase()], ['desc', 'asc'])
         .value();
   }

   @Selector([SamwinAcdExtensionState])
   public static isAcdExtensionAssigned(state: SamwinAcdExtensionStateModel): boolean {
      return !_.isNil(state.assignedAcdExtension);
   }

   @Selector([SamwinAcdExtensionStateSelectors.getCurrentAcdExtension])
   public static ringtoneUsageDisabled(currentAcdExtension: UserAcdExtensionInfoRemoteDto): boolean {
      if (_.isNil(currentAcdExtension)) {
         return false;
      }
      return currentAcdExtension.ringtoneUsageDisabled;
   }
}
